import { JsonObject } from '@bufbuild/protobuf';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

import { Injectable, signal } from '@angular/core';

import { RouterInput } from '../../../utils';

@Injectable({
  providedIn: 'root',
})
export class FraudAlertsService {
  public selectedScreenshot$ = new BehaviorSubject<any>(null);
  public fraudAlertsFilters$ = new BehaviorSubject<
    RouterInput['workflowTracker']['list'] | null
  >(null);
  public isLoading$ = signal<boolean>(false);
  public closeExpandable$ = false;
  public fraudAlertQuery$ = signal<JsonObject | null>(null);

  set fraudAlertsFilters(results: RouterInput['workflowTracker']['list']) {
    this.fraudAlertsFilters$.next(results);
  }

  set selectedScreenshot(item: any) {
    this.selectedScreenshot$.next(item);
  }

  isLoading(status: boolean) {
    this.isLoading$.set(status);
  }

  set fraudAlertQuery(detailed: JsonObject) {
    this.fraudAlertQuery$.set(detailed);
  }
}
